import React from "react";
import { Controller } from "react-hook-form";
const ControllerTextInputTwoRow = ({
  placeholder = "",
  labelClass = "label-control-v2",
  inputClass = "form-control input-v2",
  wrapperClass = "form-group",
  inputWrapClass = "col-md-8",
  labelText = "",
  starRed = "",
  inputProps = {},
  error,
}) => {
  return (
    <div className="row" style={{marginLeft:"0px", paddingRight: "15px"}} >
      <label className="label-control color7-bold"> {labelText} <span className="canh-bao-red">{starRed}</span></label>
      <br />
      <div style={{display:"contents"}} className="col-md-10">
        <Controller
          control={inputProps.control}
          rules={inputProps.rules}
          name={inputProps.name}
          defaultValue={inputProps.value}
          render={({ onChange, onBlur, value }) => (
            <input
              type="text"
              className={inputClass}
              placeholder={placeholder}
              onChange={onChange}
              value={value}
              onBlur={onBlur}
              disabled={inputProps.disabled}
            />
          )}
        />

        {error && <span className="canh-bao-red">{error.message}</span>}
      </div>
    </div>
  );
};
export default ControllerTextInputTwoRow;
